module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1011-a2f5310e560a58a1348b4aa4bbeec65d.png";